<template>
  <!--实时异常报警列表-->
  <dv-border-box-1>
    <div class="item" :style="{ height: col + 'vh' }">
      <dv-scroll-board :style="{ height: col + 'vh' }" :config="config" />
    </div>
  </dv-border-box-1>
</template>

<script>
import differenceInMinutes from "date-fns/differenceInMinutes";
import dateFormat from "date-fns/format";
export default {
  name: "andon-center",
  props: {
    col: {
      type: Number,
      default: function () {
        return 28;
      },
    },
    tasks: {
      type: Array,
      default: function () {
        return [];
      },
    },
    statusMap: { 0: "待确认", 1: "待处理", 2: "处理中", 3: "待评价" },
  },
  data() {
    return {
      list: [],
      taskList: this.tasks,
      cookie: undefined,
      refreshTime: undefined,
      config: {
        startCharts: "",
        header: ["呼叫编号", "产线", "状态", "时长", "负责人", "开始时间"],
        headerBGC: "rgba(6, 30, 93, 0.5)",
        oddRowBGC: "rgba(0, 44, 81, 0.8)",
        evenRowBGC: "rgba(10, 29, 50, 0.8)",
        rowNum: 6,
        //columnWidth: [120, 100, 80, 80, 80,80],
        data: [],
      },
    };
  },
  watch: {
    tasks: {
      handler: function (val, oldVal) {
        this.taskList = val;
        this.refreshTask(true);
      },
      deep: true,
    },
  },
  mounted() {
    var _this = this;

    //实时刷新,只为损耗时间
    _this.refreshTime = setInterval(_this.refreshTask, 1000 * 60 * 5);
  },
  methods: {
    dateFormat(uninx) {
      var now = new Date().getTime();
      return differenceInMinutes(now, uninx) + "分钟";
    },
    dateFormatEd(uninx) {
      var ym = dateFormat(new Date(uninx), "dd HH:mm");
      return ym;
    },
    refreshTask(ref = false) {
      var task = this.taskList;
      var data = [];
      for (var i = 0; i < task.length; i++) {
        var map = { 0: "待确认", 1: "待处理", 2: "处理中", 3: "待评价" };
        var name = task[i]["currentHandler"]
          ? task[i]["currentHandler"]["name"]
          : "待响应";
        var status = map[task[i]["status"]];
        var time = this.dateFormat(task[i]["createdTime"]);
        var createdTime = this.dateFormatEd(task[i]["createdTime"]);
        var station ="待确认";
        if(task[i]["device"] && task[i]["device"]["station"] 
              && task[i]["device"]["station"]["productionLine"]){
            station = task[i]["device"]["station"]["productionLine"]['title'];
        }
        var value = [
          task[i]["callCode"],
          station,
          status,
          time,
          name,
          createdTime,
        ];
        data.push(value);
      }
      this.config = {
        startCharts: "",
        header: ["呼叫编号", "产线", "状态", "损耗", "负责人", "开始时间"],
        headerBGC: "#018DCE",
        oddRowBGC: "rgba(0, 44, 81, 0.8)",
        evenRowBGC: "rgba(10, 29, 50, 0.8)",
        rowNum: 6,
        //columnWidth: [120, 100, 80, 80, 80,80],
        data: data,
      };
    },
  },
  destroyed() {
    if (this.cookie) {
      clearInterval(this.cookie);
    }
    if (this.refreshTime) {
      clearInterval(this.refreshTime);
    }
  },
};
</script>


<style scoped>
#child2 {
  scroll-behavior: smooth;
}
#child1 {
  scroll-behavior: smooth;
}
.item {
  padding: 0.33rem 0.4rem;
}
/* 头部标题 */
.head {
  list-style: none;
  margin: 0;
  padding: 0;
}
.head li {
  float: left;
  width: 200px;
  line-height: 40px;
  text-align: center;
}
.parent {
  overflow: hidden;
}
/*设置的子盒子高度大于父盒子，产生溢出效果*/
.child {
  height: auto;
  list-style: none;
  margin: 0;
  padding: 0;
}
.child li {
  text-align: center;
}
.li_item {
  width: 49.3%;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/pages/andon/component/alert-list.vue